"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("../styles/_asset-details.scss");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var AssetDetail = function AssetDetail(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      fileName = _ref.fileName;
  return _react.default.createElement("div", {
    className: "library-asset-details"
  }, _react.default.createElement("div", null, _react.default.createElement("p", {
    className: "library-asset-details__text library-asset-details__title"
  }, _react.default.createElement("strong", null, title || fileName)), _react.default.createElement("p", {
    className: "library-asset-details__text library-asset-details__sub-title"
  }, subTitle), title && title !== fileName ? _react.default.createElement("div", {
    className: "library-asset-details__text library-asset-details__filename"
  }, _react.default.createElement("strong", null, fileName)) : null));
};

var _default = (0, _react.memo)(AssetDetail);

exports.default = _default;